import { maybeHandleOpenRedirect } from "./utils/open-redirect";

// Static imports all land in one chunk, so an early return inside the old entry would
// still have booted the whole app before redirecting. The dynamic import is what skips
// it, and it keeps /open outside the auth controller, which renders nothing without a
// session and is why no route is reachable logged out.
if (!maybeHandleOpenRedirect()) {
  import("./bootstrap").catch(() => {
    // bootstrap.tsx carries the chunk-error handler, so it cannot catch its own failure
    // — usually a stale chunk after a deploy. Reload once; a flag stops a boot loop.
    const RETRIED = "tc:bootstrap-retried";
    if (sessionStorage.getItem(RETRIED)) return;
    sessionStorage.setItem(RETRIED, "1");
    window.location.reload();
  });
}
